import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as getTime from '~/skills/getTime';
import Paper from '@material-ui/core/Paper';

import SearchBar from '~/components/SearchBar';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_ErrorText, EAA_Memo, EAA_Add_Btn } from '~/components/EditAndAddItem';
import PickSqCheckBox from '~/components/CheckBox/PickSqCheckBox';

import WorkingShipCommandCenter from './WorkingShipCommandCenter';
import ShipSchedule from './ShipSchedule';


const itmeList = z => {
  switch (z) {
    case 'z1': return [{ value: 'PP', name: 'PP' }, { value: 'MP', name: 'MP' }];
    case 'z2': return [{ value: 'Jacket', name: 'Jacket' }, { value: 'TP', name: 'TP' }];
    case 'z3': return [{ value: '風力機', name: '風力機' }];
    case 'z4': return [{ value: '併網', name: '併網' }];
    default:return [];
  }
};

const Area = ({ defaultOpen, title, PPDailyPreIdDetail, editYesterDay, ...props }) => {
  const { titleWidth, disabled, returnInputValue, checkChange, changeData, data, z, errorBody = {}, errorLeft } = props;
  
  const boatList = useSelector(state => state.data.PPDailyBoatList || []);
  const havePreId = PPDailyPreIdDetail.length > 0;
  let forceOpen = false;

  useEffect(() => {
  }, []);

  for (const key of Object.keys(errorBody)) {
    if (key.match(z) && errorBody[key]) forceOpen = true;
  }
  let yesterdayText = '';
  for (const o of PPDailyPreIdDetail) {
    if (o.zone_name === z)yesterdayText = o.preprocess;
  }

  const count_today_have_done = (zone) => {
    const previous_key = `${zone}_previous_have_do_allnum`;
    const previous_num = data?.previous_have_do_allnum?.[previous_key] || 0;
    const today_num = data[`${z}_have_do_allnum`] || 0;

    return today_num - previous_num;
  };

  return (
    <SearchBar style={{ marginTop: 8 }} text={title} defaultOpen={defaultOpen} forceOpen={forceOpen}>
      <EAA_Row>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text='項目' bol={true} haveChange={checkChange(`${z}_base_type`)} />
            <EAA_Select displayBorder disabled={disabled} list={itmeList(z)} value={returnInputValue(data[`${z}_base_type`])} onChange={data => changeData({ label: `${z}_base_type`, data })} />
          </EAA_ItemContainer>
          {errorBody[`${z}_base_type`] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
        </EAA_Item>
        <EAA_Item />
      </EAA_Row>

      <EAA_Row>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth+50} text={(z === 'z4')? '今日應申請' : '累計至今日應完成'} bol={true} haveChange={checkChange(`${z}_should_do_allnum`)} />
            <EAA_Input displayBorder disabled={disabled} type='number' hint='請填寫數量' value={returnInputValue(data[`${z}_should_do_allnum`])} onChange={data => changeData({ label: `${z}_should_do_allnum`, data })} />
          </EAA_ItemContainer>
          {errorBody[`${z}_should_do_allnum`] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
        </EAA_Item>
        {
          (z === 'z1' || z === 'z2') &&
          <>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth+50} text='累計至今日已完成' bol={true} haveChange={checkChange(`${z}_have_do_allnum`)} />
                <EAA_Input displayBorder disabled={disabled} type='number' hint='請填寫數量' value={returnInputValue(data[`${z}_have_do_allnum`])} onChange={data => changeData({ label: `${z}_have_do_allnum`, data })} />
              </EAA_ItemContainer>
              {errorBody[`${z}_have_do_allnum`] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>

            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth+50} text='今日新增量' />
                {count_today_have_done(z)}
              </EAA_ItemContainer>
            </EAA_Item>

          </>
        }
        {
          (z === 'z3') && <EAA_Item></EAA_Item>
        }
        {
          (z === 'z4') &&
          <>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='今日已申請' bol={true} haveChange={checkChange(`${z}_have_do_allnum`)} />
                <EAA_Input displayBorder disabled={disabled} type='number' hint='請填寫數量' value={returnInputValue(data[`${z}_have_do_allnum`])} onChange={data => changeData({ label: `${z}_have_do_allnum`, data })} />
              </EAA_ItemContainer>
              {errorBody[`${z}_have_do_allnum`] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='今日已併網' bol={true} haveChange={checkChange(`${z}_have_been_grid_conneciton_num`)} />
                <EAA_Input displayBorder disabled={disabled} type='number' hint='請填寫數量' value={returnInputValue(data[`${z}_have_been_grid_conneciton_num`])} onChange={data => changeData({ label: `${z}_have_been_grid_conneciton_num`, data })} />
              </EAA_ItemContainer>
              {errorBody[`${z}_have_been_grid_conneciton_num`] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </>
        }
      </EAA_Row>

      {
        (z === 'z3') &&
        <>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='塔架' bol={false} haveChange={checkChange(`${z}_tower_num`)} />
                <PickSqCheckBox
                    disabled={disabled}
                    value={data[`${z}_tower_check`] === '1'}
                    onClick={() => changeData({ label: `${z}_tower_check`, data: data[`${z}_tower_check`] === '1' ? '0' : '1' })}
                />
                <div style={{ marginLeft: 8, marginRight: 8 }}> </div>
                <EAA_Input
                  displayBorder
                  disabled={disabled || data[`${z}_tower_check`] !== '1'}
                  type='number'
                  hint='請填寫數量'
                  value={returnInputValue(data[`${z}_tower_num`])}
                  onChange={data => changeData({ label: `${z}_tower_num`, data })}
                />
              </EAA_ItemContainer>
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='機艙' bol={false} haveChange={checkChange(`${z}_cabin_num`)} />
                <PickSqCheckBox
                    disabled={disabled}
                    value={data[`${z}_cabin_check`] === '1'}
                    onClick={() => changeData({ label: `${z}_cabin_check`, data: data[`${z}_cabin_check`] === '1' ? '0' : '1' })}
                />
                <div style={{ marginLeft: 8, marginRight: 8 }}> </div>
                <EAA_Input
                  displayBorder
                  disabled={disabled || data[`${z}_cabin_check`] !== '1'}
                  type='number'
                  hint='請填寫數量'
                  value={returnInputValue(data[`${z}_cabin_num`])}
                  onChange={data => changeData({ label: `${z}_cabin_num`, data })}
                />
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='葉片' bol={false} haveChange={checkChange(`${z}_blade_num`)} />
                <PickSqCheckBox
                    disabled={disabled}
                    value={data[`${z}_blade_check`] === '1'}
                    onClick={() => changeData({ label: `${z}_blade_check`, data: data[`${z}_blade_check`] === '1' ? '0' : '1' })}
                />
                <div style={{ marginLeft: 8, marginRight: 8 }}> </div>
                <EAA_Input
                  displayBorder
                  disabled={disabled || data[`${z}_blade_check`] !== '1'}
                  type='number'
                  hint='請填寫數量'
                  value={returnInputValue(data[`${z}_blade_num`])}
                  onChange={data => changeData({ label: `${z}_blade_num`, data })}
                />
              </EAA_ItemContainer>
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='風力機' bol={false} haveChange={checkChange(`${z}_wind_turbine_num`)} />
                <PickSqCheckBox
                    disabled={disabled}
                    value={data[`${z}_wind_turbine_check`] === '1'}
                    onClick={() => changeData({ label: `${z}_wind_turbine_check`, data: data[`${z}_wind_turbine_check`] === '1' ? '0' : '1' })}
                />
                <div style={{ marginLeft: 8, marginRight: 8 }}> </div>
                <EAA_Input
                  displayBorder
                  disabled={disabled || data[`${z}_wind_turbine_check`] !== '1'}
                  type='number'
                  hint='請填寫數量'
                  value={returnInputValue(data[`${z}_wind_turbine_num`])}
                  onChange={data => changeData({ label: `${z}_wind_turbine_num`, data })}
                />
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
        </>
      }

      {/* 工作船舶指揮中心 */}
      <WorkingShipCommandCenter
        items={boatList}
        max={2}
        schedule={{...props}}
      />
       
    </SearchBar>
  );
};

export default Area;
